import useSWR from 'swr'

import { FetchError } from '../../../../../data/fetchError'
import { FetchResponse } from '../../../../../data/fetchResponse'
import { FetchResult } from '../../../../../data/fetchResult'
import { fetchJson } from '../../../../../data/fetchers'
import { DeliveryForecastDespatchAdvicePackagingMaterial } from '../../../../../data/models'

export function useAllPackagingMaterial(): FetchResult<
  DeliveryForecastDespatchAdvicePackagingMaterial[]
> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastDespatchAdvicePackagingMaterial[]>,
    FetchError
  >(
    `/masterdata/packagingdata`,
    fetchJson<DeliveryForecastDespatchAdvicePackagingMaterial[]>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function usePackagingMaterialById(
  id?: string,
): FetchResult<DeliveryForecastDespatchAdvicePackagingMaterial> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastDespatchAdvicePackagingMaterial>,
    FetchError
  >(
    `/masterdata/packagingdata/${id}`,
    id ? fetchJson<DeliveryForecastDespatchAdvicePackagingMaterial> : null,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
